<template>
    <div class="wrapper">
        <div class="section section-blogs-2 topsearch">
            <div class="container main">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <router-link
                            :to="{
                                name: 'sourceNameList',
                                params: { dictionaryId: dictCode, page: page },
                            }"
                            id="buttonback"
                        >
                            <md-icon>keyboard_arrow_left</md-icon>
                            Назад к списку справочников
                        </router-link>
                    </div>
                    <div
                        class="md-layout-item md-size-100 md-small-size-100 mx-auto"
                    >
                        <div class="name">
                            <h3 class="title">
                                Редактирование элемента справочника SourceName
                            </h3>
                            <div
                                class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep"
                                v-if="selectedDataId"
                            >
                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('name')"
                                    >
                                        <label>{{
                                            mapElementName['name']
                                        }}</label>
                                        <md-input
                                            readonly
                                            type="text"
                                            v-if="action === 'delete'"
                                            v-model.number="form['name']"
                                        ></md-input>
                                        <md-input
                                            type="text"
                                            v-else
                                            v-model="form['name']"
                                        ></md-input>
                                        <span
                                            class="md-error"
                                            v-if="!$v.form.name.required"
                                            >Обязательно для заполнения</span
                                        >
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('desc')"
                                    >
                                        <label>{{
                                            mapElementName['desc']
                                        }}</label>
                                        <md-input
                                            readonly
                                            type="text"
                                            v-if="action === 'delete'"
                                            v-model.number="form['desc']"
                                        ></md-input>
                                        <md-input
                                            type="text"
                                            v-else
                                            v-model="form['desc']"
                                        ></md-input>
                                        <span
                                            class="md-error"
                                            v-if="!$v.form.desc.required"
                                            >Обязательно для заполнения</span
                                        >
                                    </md-field>
                                </div>

                                <div
                                    class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
                                >
                                    <md-field
                                        :class="getValidationClass('status')"
                                    >
                                        <label>{{
                                            mapElementName['status']
                                        }}</label>
                                        <md-select v-model="form.status">
                                            <md-option value="A"
                                                >Активный</md-option
                                            >
                                            <md-option value="I"
                                                >Неактивный</md-option
                                            >
                                        </md-select>
                                    </md-field>
                                </div>
                            </div>
                            <br />
                            <div
                                class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep"
                            >
                                <template v-if="selectedDataId">
                                    <md-button
                                        @click="validateData(saveItem)"
                                        class="md-button md-success md-theme-default"
                                        v-if="action !== 'delete'"
                                    >
                                        Сохранить
                                    </md-button>

                                    <md-button
                                        @click="validateData(deleteItem)"
                                        class="md-button md-primary  md-theme-default"
                                        v-if="action === 'delete'"
                                    >
                                        Удалить
                                    </md-button>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { checkAuthentication, reAuthenticate } from '@/utils/auth-api';
import { required } from 'vuelidate/lib/validators';
import { saveItem, getItem, deleteItem } from '@/utils/dict-api';
import { appConfig } from '../../utils/config-api';

export default {
    mixins: [validationMixin],
    bodyClass: 'dictionary-data',
    props: ['page', 'action'],
    data() {
        return {
            options: [],
            dictCode: 'sourcename',
            dictionaryId: '',
            selectedDataId: this.$route.params.id,
            selectedData: null,
            form: {
                action: 'save',
                name: '',
                desc: '',
            },
            mapElementName: {
                locOrder: 'Порядок отображения',
                name: 'SourceName(название)',
                desc: 'Описание',
            },
            status: {},
        };
    },
    validations: {
        form: {
            name: {
                required,
            },
            desc: {
                required,
            },
        },
    },
    methods: {
        getValidationClass(fieldName) {
            const field = this.$v.form[fieldName];
            if (field) {
                return {
                    'md-invalid': field.$invalid && field.$dirty,
                };
            }
        },
        validateData(sendFn) {
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                sendFn();
            }
        },
        setData: function(data) {
            this.form = data;
        },
        getElementData: function() {
            if (this.selectedDataId === 'new') {
                this.addItem();
                return;
            }
            checkAuthentication(this.$router, this.$route).then(response => {
                getItem(this.dictCode, this.selectedDataId)
                    .then(result => {
                        this.setData(result);
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        addItem: function() {
            const item = {
                id: 'new',
                name: '',
                desc: '',
                status: '',
            };
            this.setData(item);
        },
        saveItem: function() {
            if (this.form.id === 'new') {
                this.form.id = null;
            }
            checkAuthentication(this.$router, this.$route).then(response => {
                saveItem(this.dictCode, JSON.stringify(this.form))
                    .then(result => {
                        this.$router.push({ name: 'sourceNameList' });
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        deleteItem: function() {
            checkAuthentication(this.$router, this.$route).then(response => {
                deleteItem(
                    this.dictCode,
                    JSON.stringify({ id: this.$route.params.id })
                )
                    .then(result => {
                        this.$router.push({ name: 'sourceNameList' });
                    })
                    .catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
            });
        },
        checkEditableNames: function(name) {
            const editableNames = ['valueId', 'value', 'order'];
            return editableNames.indexOf(name) >= 0;
        },
    },
    created() {
        if (this.$route.params.action === 'delete') {
            this.deleteItem();
        } else {
            this.getElementData();
        }
    },
};
</script>

<style lang="scss" scoped type="text/scss">
.dictionary-data .md-field {
    padding-top: 16px;
    margin: 4px 0 24px;
}

.offset-left-16 {
    margin-left: 16px;
}
</style>
